module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm6"
    }
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("Elegy for Sabina 1968")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("Now, sweet witch cat")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("Free from flesh,")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("May you hunt")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("Happily")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("in the fields of Heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication2"
  }, [_vm._v("Composed by Grace Warren for Sabina.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a426c02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Elegy_for_Sabina.vue
// module id = 69
// module chunks = 0